/*jshint esversion: 8 */
/*jshint multistr: true */
import tricks from "./tricks";

$(function () {
	SetListenersCutBannerStep1();
	SetListenersCutBannerStep2();
});

function SetListenersCutBannerStep1() {
	//Banner de corte submit 1
	const FieldsStep1 = ["email", "tel"];

	$('.submitButton[data-step="1"]').on('click', function(event){
		event.preventDefault();

		//Store button
		const buttonElement = $(event.target);

		//Partially serialize form
		let formData = $(".static #formCorteConsulta").serializeArray().filter(function(item) {
			return FieldsStep1.includes(item.name);
		});

		formData = $.param(formData);

		$.ajax({
			type: 'POST',
			url: '/banner-corte-1',
			headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
			data: formData,
			success: function(response) {
				//Clear validation errors
				$(`.validationText ul`).empty();
				$(`[data-errorMark]`).removeClass('vError');

				//Handle validation errors
				if (response.hasOwnProperty('validationFailed')) {
					//Print validation errors
					$.each(response.validationErrors, function(field, errors){
						//Set markers
						$(`[data-errorMark="${field}"]`).addClass('vError');

						//Print errors
						$.each(errors, function(key, text){
							$(`.validationText[data-field="${field}"] ul`).append(`<li>${text}</li>`);
						});
					});

					//Restore button
					buttonElement.siblings('.buttonLoader').remove();
					buttonElement.show();

					return;
				}

				//Handle user cases
				switch (response.userType){
					case "full":
					case "test":
						if (window.ADWordsLanding) {
							//Alert + double option (landing adwords)
							Swal.fire({
								title: 'Ya estás registrado en LexaGo',
								text: '¿Qué deseas hacer?',
								icon: 'info',
								confirmButtonText: 'Acceder',
								showCancelButton: true,
								cancelButtonText: 'Recordar contraseña',
								buttonsStyling: false,
								customClass: {
								  confirmButton: 'btn submitButton mr-4',
								  cancelButton: 'btn submitButton'
								}
							  }).then((result) => {
								if (result.isConfirmed) //Acceder
								  window.location.href = "https://app.lexa-go.com/login";
								else if (result.dismiss === Swal.DismissReason.cancel) // Realizar nueva consulta
								  window.location.href = "https://app.lexa-go.com/password/reset";
								else if (result.isDismissed) {
									//Restore button && clear fields
									buttonElement.siblings('.buttonLoader').remove();
									buttonElement.show();
								}
							});
						} else {
							//Alert + double option
							Swal.fire({
								title: 'Ya estás registrado en LexaGo',
								text: '¿Qué deseas hacer?',
								icon: 'info',
								confirmButtonText: 'Ver esta consulta',
								showCancelButton: true,
								cancelButtonText: 'Realizar una nueva consulta',
								buttonsStyling: false,
								customClass: {
								confirmButton: 'btn submitButton mr-4',
								cancelButton: 'btn submitButton'
								}
							}).then((result) => {
								if (result.isConfirmed) //Ver consulta
								window.location.href = $("#clientLink").val();
								else if (result.dismiss === Swal.DismissReason.cancel) // Realizar nueva consulta
								window.location.href = "https://app.lexa-go.com/login";
								else if (result.isDismissed) {
									//Restore button && clear fields
									buttonElement.siblings('.buttonLoader').remove();
									buttonElement.show();
								}
							});
						}
					break;
					case "new":
					case "light":
						//Continue to second step
						GoToStep2();
					break;
				}


			},
			error: function(xhr, status, error) {
				console.log(error);
				tricks.HandleAxiosErrors(xhr.status);
			}
		});
	});
}

function SetListenersCutBannerStep2() {
	//Banner de corte submit 1
	const FieldsStep1 = ["email", "tel", "question", "politica_de_privacidad"];

	$('.submitButton[data-step="2"]').on('click', function(event){
		event.preventDefault();

		//Store button
		const buttonElement = $(event.target);

		//Partially serialize form
		let formData = $(".static #formCorteConsulta").serializeArray().filter(function(item) {
			return FieldsStep1.includes(item.name);
		});
		formData = $.param(formData);

		$.ajax({
			type: 'POST',
			url: '/banner-corte-2',
			headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
			data: formData,
			success: function(response) {
				//Clear validation errors
				$(`.validationText ul`).empty();
				$(`[data-errorMark]`).removeClass('vError');

				//Handle validation errors
				if (response.hasOwnProperty('validationFailed')) {
					//Print validation errors
					$.each(response.validationErrors, function(field, errors){
						//Set markers
						$(`[data-errorMark="${field}"]`).addClass('vError');

						//Print errors
						$.each(errors, function(key, text){
							$(`.validationText[data-field="${field}"] ul`).append(`<li>${text}</li>`);
						});
					});

					//Restore buttons
					console.log(buttonElement);
					buttonElement.siblings('.buttonLoader').remove();
					buttonElement.show();

					return;
				}

				//Report conversion from adwords landing
				if (typeof gtag === 'function') {
					gtag('event', 'conversion', {
						'send_to': 'AW-11157346389/axIiCIaikZoYENWwnsgp',
						'event_callback': null
					});
				}

				Swal.fire({
					title: "¡Gracias!",
					text: "Revisa tu correo electrónico para leer la respuesta a tu consulta",
					icon: "info",
					confirmButtonText: 'De acuerdo',
					buttonsStyling: false,
					customClass: {
						confirmButton: 'submitButton swalButton',
					}
				});

				ResetBanner();
			},
			error: function(xhr, status, error) {
				console.log(error);
				tricks.HandleAxiosErrors(xhr.status);
			}
		});
	});
}

function ResetBanner() {
	$('.formStep[data-step="2"]').fadeOut(400, "swing", function(){
		$('.formStep[data-step="1"]').fadeIn();
	});

	$(".static #formCorteConsulta")[0].reset();
	$(".submitButton").siblings('.buttonLoader').remove();
	$(".submitButton").show();

	if ($('#modalBannerCorte').length > 0)
		$('#modalBannerCorte').modal('hide');
}

function GoToStep2() {
	$('.formStep[data-step="1"]').fadeOut(400, "swing", function(){
		$('.formStep[data-step="2"]').fadeIn(400, "swing", function(){
			$(".static .questionInput").trigger('focus');
		});
	});
}